// Add your custom JS here.

var $=jQuery.noConflict();

jQuery(function() {
    "use strict";


///////////////////////////////////////
// Browser Detection
///////////////////////////////////////

  // browser detect
  var BrowserDetect = {
    init: function () {
        this.browser = this.searchString(this.dataBrowser) || "Other";
        this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "Unknown";
    },
    searchString: function (data) {
        for (var i = 0; i < data.length; i++) {
            var dataString = data[i].string;
            this.versionSearchString = data[i].subString;
  
            if (dataString.indexOf(data[i].subString) !== -1) {
                return data[i].identity;
            }
        }
    },
    searchVersion: function (dataString) {
        var index = dataString.indexOf(this.versionSearchString);
        if (index === -1) {
            return;
        }
  
        var rv = dataString.indexOf("rv:");
        if (this.versionSearchString === "Trident" && rv !== -1) {
            return parseFloat(dataString.substring(rv + 3));
        } else {
            return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
        }
    },
  
    dataBrowser: [
        {string: navigator.userAgent, subString: "Edge", identity: "MS Edge"},
        {string: navigator.userAgent, subString: "MSIE", identity: "Explorer"},
        {string: navigator.userAgent, subString: "Trident", identity: "Explorer"},
        {string: navigator.userAgent, subString: "Firefox", identity: "Firefox"},
        {string: navigator.userAgent, subString: "Opera", identity: "Opera"},  
        {string: navigator.userAgent, subString: "OPR", identity: "Opera"},  
  
        {string: navigator.userAgent, subString: "Chrome", identity: "Chrome"}, 
        {string: navigator.userAgent, subString: "Safari", identity: "Safari"}       
    ]
  };
  
  BrowserDetect.init();
  //alert("You are using - " + BrowserDetect.browser + " - version - " + BrowserDetect.version + ".");
  
  // Done with IE11 and below | Not below Edge 18 | Not below Chrome 103 | Not below Safari 14 (610.2.11) | Not below Firefox 115.2 | Not below Opera 63
  if (BrowserDetect.browser === 'Explorer' && BrowserDetect.version <= 11 
      || BrowserDetect.browser === 'MS Edge' && BrowserDetect.version <= 18.19041
      || BrowserDetect.browser === 'Chrome' && BrowserDetect.version <= 103
      //|| BrowserDetect.browser === 'Safari' && BrowserDetect.version <= 610.2 // This is not correct as it blocks on mobile!
      || BrowserDetect.browser === 'Firefox' && BrowserDetect.version <= 115.2
      || BrowserDetect.browser === 'Opera' && BrowserDetect.version <= 63 ){
  $('#outdated').show();
  $('body').addClass("fixbody");
  $('#bVersion').empty().append( BrowserDetect.browser + " | Version " + BrowserDetect.version + " | Detected.");
  }


////////////////////////////////////////////////////
// Device and useragent checking (using Modernizr)
////////////////////////////////////////////////////
var deviceAgent = navigator.userAgent.toLowerCase();

var isTouchDevice = Modernizr.touch || 
(deviceAgent.match(/(iphone|ipod|ipad)/) ||
deviceAgent.match(/(android)/)  || 
deviceAgent.match(/(iemobile)/) || 
deviceAgent.match(/iphone/i) || 
deviceAgent.match(/ipad/i) || 
deviceAgent.match(/ipod/i) || 
deviceAgent.match(/blackberry/i) || 
deviceAgent.match(/bada/i));

if (isTouchDevice) {
    // Is touch device
    //$('.video-background').addClass("d-none"); // hide video

} else {
    // Is not touch device
    // $(window).resize(function (event) {
    //     if (Modernizr.mq('(max-width: 767px)')) {
    //         $('.video-background').addClass("d-none"); // hide video
    //     } else {
    //         $('.video-background').removeClass("d-none"); // show video
    //     }
    // });

}

});// End jQuery